<template>
  <v-container fluid class="ma-0 pa-0">
    <v-autocomplete
      :value="isDSDupload ? selectedVendor : selectedVendors"
      :items="vendors"
      item-text="name"
      item-value="vendor_id"
      label="Vendors"
      :loading="searching"
      :search-input.sync="vendorSearch"
      background-color="input"
      :placeholder="isAdmin ? 'Start typing to search' : null"
      hide-no-data
      hide-details
      :multiple="!isDSDupload"
      cache-items
      return-object
      small-chips
      deletable-chips
      dense
      outlined
      @change="handleChange">
      <template v-slot:item="{ item, attrs, on }">
        <v-list-item
          v-bind="attrs"
          color="primary"
          v-on="on">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.party_type_name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </v-container>
</template>
<script>
// API
import Search from '@/api/search'
// mixins
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
// third-party
import { debounce } from 'lodash'
export default {
  data () {
    return {
      vendors: [],
      vendorSearch: '',
      searching: false
    }
  },
  name: 'VendorSelect',
  mixins: [userAccess, displayAlert],
  props: {
    selectedVendors: Array,
    selectedVendor: Object,
    isDSDupload: Boolean
  },

  created () {
    this.initVendors()
    
    if (this.limitAccessByRelatedVendors && this.userRelatedParties.length > 0) {
      this.vendors = [...this.vendors, ...this.userDropdownParties]
    }
  },
  watch: {
    vendorSearch: {
      handler: debounce(function (newValue) {
        if (this.searchEnabled && newValue) {
          this.searchVendors()
        }
      }, 500)
    },
    selectedVendor: {
      handler (newValue) {
        if (newValue && this.isDSDupload) {
          this.vendors = [newValue]
        }
      },
      deep: true,
      immediate: true
    },
    selectedVendors: {
      handler (newValue) {
        if (newValue && newValue.length > 0 && !this.isDSDupload) {
          const currentIds = new Set(this.vendors.map(v => v.vendor_id || v.id))
          const hasChanges = newValue.some(v => !currentIds.has(v.vendor_id || v.id))
          if (hasChanges) {
            this.vendors = [...newValue]
          }
        }
      },
      deep: true,
      immediate: true
    },
    userRelatedParties: {
      handler (newValue) {
        if (newValue && newValue.length > 0 && this.limitAccessByRelatedVendors) {
          const existingIds = new Set(this.vendors.map(v => v.vendor_id || v.id))
          const newParties = this.userDropdownParties.filter(
            party => !existingIds.has(party.vendor_id || party.id)
          )
          this.vendors = [...this.vendors, ...newParties]
        }
      },
      deep: true,
      immediate: true
    }

  },
  computed: {
    userDropdownParties () {
      return this.userVendors.flatMap(vendor => this.formatParty(vendor))
    },
    searchEnabled () {
      return !this.limitAccessByRelatedVendors
    }
  },
  methods: {
    handleChange (value) {
      if (this.isDSDupload) {
        this.$emit('update:selectedVendor', value)
      } else {
        this.$emit('update:selectedVendors', value)
      }
    },
    initVendors () {
      if (this.isDSDupload && this.selectedVendor) {
        this.vendors = [this.selectedVendor]
      } else if (this.selectedVendors) {
        this.vendors = [...this.selectedVendors]
      }
    },
    async searchVendors () {
      this.searching = true
      const term = this.vendorSearch || ''
      let vendors = []
      try {
        const res = await Search.customerSearch(term, 'and')
        if (res && res.data && res.data.length > 0) {
          vendors = res.data.flatMap(party => {
            return (party.party_type) === 'VENDOR'
              ? this.formatParty(party)
              : []
          })
        }
        this.vendors = [...this.vendors, ...vendors]
      } catch (err) {
        this.handleError(err)
      } finally {
        this.searching = false
      }
    },
    formatParty (party) {
      let display_name = party.party_name || party.name
      const partyType = party.party_type_constant || party.party_type
      if (party.attributes) {
        const attrVal = party.attributes.VENDOR_ID || ''
        display_name = `${attrVal} ${display_name}`
      }
      party.name = display_name
      party.party_type_name = this.formatPartyType(partyType)
      if (!party.id) party.id = party.party_id
      return party
    },
    formatPartyType (str) {
      str = str.toLowerCase().replaceAll('_', ' ')
      const parts = str.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1))
      return parts.join(' ')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/VendorSelect.vue